"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textColorWithProps = exports.bgColorWithProps = void 0;
const styled_tools_1 = require("styled-tools");
exports.bgColorWithProps = styled_tools_1.withProp(['opaque', 'palette', 'tone'], (opaque, paletteProp, tone = 0) => {
    if (!opaque) {
        return 'unset';
    }
    return styled_tools_1.palette(paletteProp, tone, 'unset');
});
exports.textColorWithProps = styled_tools_1.withProp(['opaque', 'palette', 'tone'], (opaque, paletteProp, tone = 0) => styled_tools_1.palette(opaque ? `${paletteProp}Text` : paletteProp, tone, 'inherit'));

//# sourceMappingURL=styledProps.js.map
